import React from 'react';
import { Empty, Tag } from 'antd';
import type { ProcessBasicInfo } from '../types';

interface BasicInfoTabProps {
  info: ProcessBasicInfo | null;
}

const FieldBlock: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-xs font-medium text-gray-500">{label}</div>
      <div>{children}</div>
    </div>
  );
};

const TextValue: React.FC<{
  value?: string;
  multiline?: boolean;
}> = ({ value, multiline = false }) => {
  const displayValue = value && value.trim() ? value : '-';

  return (
    <div
      className={`rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700 ${
        multiline ? 'min-h-[96px] whitespace-pre-wrap break-words' : ''
      }`}
    >
      {displayValue}
    </div>
  );
};

const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ info }) => {
  if (!info) {
    return <Empty description="暂无 Process 基本信息" />;
  }

  return (
    <div className="flex flex-col gap-6 py-2">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <FieldBlock label="显示名称">
          <TextValue value={info.name} />
        </FieldBlock>

        <FieldBlock label="英文名称">
          <TextValue value={info.codeName} />
        </FieldBlock>
      </div>

      <FieldBlock label="描述">
        <TextValue value={info.description} multiline />
      </FieldBlock>

      <FieldBlock label="标签">
        {info.tags.length ? (
          <div className="flex flex-wrap gap-2">
            {info.tags.map((tag, index) => (
              <Tag key={`${tag}-${index}`} color="blue" className="!m-0">
                {tag}
              </Tag>
            ))}
          </div>
        ) : (
          <div className="text-sm text-gray-400">暂无标签</div>
        )}
      </FieldBlock>
    </div>
  );
};

export default BasicInfoTab;
